export const findInHistory = (path) => {
	const entries = window.history.stack || []

	console.log('findhistory', { entries, }, window.history.state)
    const idx = entries.findIndex(entry => entry === path)

	let steps = -1
    if (idx !== -1) {
        steps = -(entries.length - idx - 1)
    }
	window.history.stack = []
	return steps
}

export const $src = (url) => {
	if (!url) return null
	const prefix = `/src`
	const src = `${prefix}${url}`
	const modules = import.meta.glob('/src/assets/**/*', { eager: true})
	const mod = modules[src]
	if (mod?.default) return mod.default
	console.warn(`$src 404: ${url}`)
	return
}

export const $public = (url) => {
	if (!url) return null
	if (import.meta.env.DEV) return url
	const prefix = import.meta.env.BASE_URL || ''
	const src = [prefix, url.replace(/^\/+/, '')].join(`/`)
	console.log({ src, })
	return src
}
